<template>
  <div class="audit-timeline" v-loading="loading">
    <div v-if="!list.length && !loading" class="empty">暂无审核记录</div>
    <el-timeline v-else>
      <el-timeline-item
        v-for="(item, idx) in list" :key="idx"
        :timestamp="item.createTime"
        :color="dotColor(item)"
        placement="top">
        <el-card shadow="never" class="timeline-card">
          <div class="row1">
            <el-tag size="mini" :type="typeTag(item.type, item.action)">{{ typeLabel(item.type, item.action) }}</el-tag>
            <el-tag size="mini" effect="plain" style="margin-left:6px">{{ stageLabel(item.stage) }}</el-tag>
            <span class="action" :class="actionClass(item.action)">{{ actionLabel(item.action) }}</span>
            <span v-if="item.operatorName" class="operator">— {{ item.operatorName }}</span>
          </div>
          <div v-if="item.remark" class="remark">{{ item.remark }}</div>
          <div v-if="item.aiTaskId" class="ai-task-ref">
            <el-button type="text" size="mini" @click="$emit('ai-detail', item.aiTaskId)">
              查看 AI 任务详情 #{{ item.aiTaskId }}
            </el-button>
          </div>
        </el-card>
      </el-timeline-item>
    </el-timeline>
  </div>
</template>

<script>
import { getSpendingAuditHistory } from '@/request/api.js';

const STAGE_LABEL = {
  SUPPLIER: '供应商/助教', ASSISTANT: '助教',
  AI: 'AI 审核', OFFICIAL: '官员审核',
  OFFICIAL_SETTLEMENT: '结算官员', OFFICIAL_AUDIT: '审核官员',
  FINANCE: '财务',
  // 角色作为 stage 时(用于材料相关日志)
  ADMIN: '管理员', DOCTOR: '医生'
};
const ACTION_LABEL = {
  // 主流程动作
  create: '创建', submit: '提交', approve: '通过', reject: '驳回',
  withdraw: '撤回', push_k3: '推送金蝶',
  // 状态机新动作(uppercase)
  CREATE: '创建', SUBMIT: '提交', APPROVE: '通过', REJECT: '驳回',
  ENTER_MATERIAL: '进入材料收集', SUBMIT_AUDIT: '提交审核',
  RETURN: '退回',
  // AI 审核结果
  PASS: '全部通过', WARN: '有警告', FAILED: '执行失败',
  // 材料动作
  MATERIAL_UPLOAD: '上传材料', MATERIAL_REPLACE: '替换材料',
  MATERIAL_REMOVE: '删除材料', MATERIAL_MARK_ISSUE: '标记需重传',
  MATERIAL_OVERRIDE: '越权替换材料'
};

export default {
  name: 'AuditTimeline',
  props: {
    orderId: { type: [Number, String], default: null }
  },
  data() {
    return { list: [], loading: false };
  },
  watch: {
    orderId: {
      immediate: true,
      handler(v) { if (v) this.load(); else this.list = []; }
    }
  },
  methods: {
    stageLabel(s) { return STAGE_LABEL[s] || s || '-'; },
    actionLabel(a) { return ACTION_LABEL[a] || a || ''; },
    typeTag(t, action) {
      if (t === 'AI') return 'warning';
      // 材料类动作归为 info, 视觉与审核区分
      if (action && action.startsWith && action.startsWith('MATERIAL_')) return 'info';
      return 'primary';
    },
    typeLabel(t, action) {
      if (t === 'AI') return 'AI 审核';
      if (action && action.startsWith && action.startsWith('MATERIAL_')) return '材料操作';
      return '人工';
    },
    actionClass(a) {
      if (['approve', 'APPROVE', 'PASS', 'MATERIAL_UPLOAD'].indexOf(a) >= 0) return 'ok';
      if (['reject', 'REJECT', 'FAILED', 'MATERIAL_REMOVE', 'MATERIAL_MARK_ISSUE'].indexOf(a) >= 0) return 'fail';
      if (['WARN', 'MATERIAL_REPLACE', 'MATERIAL_OVERRIDE', 'SUBMIT_AUDIT', 'ENTER_MATERIAL'].indexOf(a) >= 0) return 'warn';
      return '';
    },
    dotColor(item) {
      const a = item.action;
      if (['approve', 'APPROVE', 'PASS', 'MATERIAL_UPLOAD'].indexOf(a) >= 0) return '#67C23A';
      if (['reject', 'REJECT', 'FAILED', 'MATERIAL_REMOVE', 'MATERIAL_MARK_ISSUE'].indexOf(a) >= 0) return '#F56C6C';
      if (['WARN', 'MATERIAL_REPLACE', 'MATERIAL_OVERRIDE', 'SUBMIT_AUDIT', 'ENTER_MATERIAL'].indexOf(a) >= 0) return '#E6A23C';
      return '#409EFF';
    },

    async load() {
      this.loading = true;
      try {
        const resp = await getSpendingAuditHistory(this.orderId);
        if (resp.code === 200) this.list = resp.data || [];
      } catch (e) {
        this.$message.error('审核记录加载失败');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.audit-timeline { padding: 8px; }
.empty { color: #909399; text-align: center; padding: 40px 0; }
.timeline-card { background: #FAFAFA; }
.row1 { display: flex; align-items: center; flex-wrap: wrap; gap: 4px; }
.action { margin-left: 8px; font-weight: 600; }
.action.ok { color: #67C23A; }
.action.fail { color: #F56C6C; }
.action.warn { color: #E6A23C; }
.operator { color: #606266; margin-left: 6px; font-size: 13px; }
.remark { margin-top: 6px; color: #606266; font-size: 13px; line-height: 1.5; }
.ai-task-ref { margin-top: 4px; }
</style>
